<div class="panel-title">
  My Balances |
  <span class="panel-sub-title">Your funds held in specific currencies</span>
</div>

<div class="my-balance client-dashboard-session" *ngIf="!isLoading">
  <div *ngIf="!balances || balances.length === 0">
    <ul class="balance-list no-data">
      <li>
        <div class="balance-item currency-flag">
          <span class="flag-icon flag-icon-gb icon-flag"></span>
        </div>
        <div class="balance-item currency">
          <span>GBP</span>
        </div>
        <div class="balance-item currency-name">
          <span>Pound Sterling</span>
        </div>
      </li>
      <li *ngFor="let index of [0, 1, 2, 3, 4, 5, 6, 7]"></li>
    </ul>
    <div class="overlay-no-data">
      <div class="notify-no-data">
        Fund your account,
        <br /> currency balances
        <br /> will display here
      </div>
    </div>
  </div>

  <ng-container *ngIf="balances && balances.length > 0 && balances.length <= 10">
    <ul class="balance-list">
      <li *ngFor="let balance of balances">
        <div class="balance-item currency-flag">
          <span class="{{ balance.currencyCode | flagIcon }} icon-flag"></span>
        </div>
        <div class="balance-item currency">
          <span>{{ balance.currencyCode }}</span>
        </div>
        <div class="balance-item currency-name">
          <span>{{ balance.currencyName }}</span>
        </div>
        <div class="balance-item amount ml-auto" [class.amount-negative]="balance.amount < 0">
          <span>{{ balance.amount | transformNumber }}</span>
        </div>
        <div class="balance-without-info-icon" *ngIf="balance.totalItemsInBreakdown === 0"></div>
        <div class="balance-item icon-notify" *ngIf="balance.totalItemsInBreakdown !== 0"><img class="icon-info" (click)="showBalanceHistory(balance)" src="./assets/images/icon-png/icon-info-dark.svg" alt="" /></div>
      </li>
    </ul>
  </ng-container>
  <ng-container *ngIf="balances && balances.length > 10">
    <cdk-virtual-scroll-viewport [itemSize]="29" class="cdk-panel">
      <ul class="balance-list">
        <li *cdkVirtualFor="let balance of balances">
          <div class="balance-item currency-flag">
            <span class="{{ balance.currencyCode | flagIcon }} icon-flag"></span>
          </div>
          <div class="balance-item currency">
            <span>{{ balance.currencyCode }}</span>
          </div>
          <div class="balance-item currency-name">
            <span>{{ balance.currencyName }}</span>
          </div>
          <div class="balance-item amount ml-auto" [class.amount-negative]="balance.amount < 0">
            <span>{{ balance.amount | transformNumber }}</span>
          </div>
          <div class="balance-without-info-icon" *ngIf="balance.totalItemsInBreakdown === 0"></div>
          <div class="balance-item icon-notify" *ngIf="balance.totalItemsInBreakdown !== 0"><img class="icon-info" (click)="showBalanceHistory(balance)" src="./assets/images/icon-png/icon-info-dark.svg" alt="" /></div>
        </li>
      </ul>
    </cdk-virtual-scroll-viewport>
  </ng-container>
</div>
